import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import NavBar from '../components/Menu/NavBar'
import { pageStyle } from '../components/UIComponent/CommonStyle'
import MyTeam from '../components/MyTeam';
import { setLocalStorageSettings } from '../components/Function/globalFunction';

const useStyles = makeStyles(() => ({
    ...pageStyle()
}));

export default function MyTeamPage({ routing, routingId, source, compLeaveRequest }) {
    const classes = useStyles();
    setLocalStorageSettings({
        'selectedIndex': 7,
        'isMyRequestOpen': 'false',
        'isApplicationOpen': 'false',
        'isLeaveApprovalOpen': 'false',
        'isHRAdminOpen': 'false'
    });
    
    return (
        <div className={classes.root}>
            <CssBaseline />
            <NavBar />
            <MyTeam routing={routing} routingId={routingId} source={source} compLeaveRequest={compLeaveRequest} />
        </div>
    )
}